import axios from 'axios'

// https://developers.google.com/sheets/api/reference/rest/v4/spreadsheets/get
export async function getSpreadsheet(spreadsheetId) {
    const API_KEY = 'AIzaSyC8moN_iOP62MS8ZoCpM9AL-pr2WLrnLzg'
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}`
    const params = {
        key: API_KEY,
    }
    const response = await axios.get(url, { params })
    return response.data
}

/**
 * Get data from Google sheets api
 * @param {String} spreadsheetsKey
 * @param {Object} objectStructure structure of the object to return. { objectKeyToReturn: 'sheetsColumnName' }. e.g. { date: 'date', info: 'info' }
 * @param {String} sheetName name of the sheet tab (case insensitive)
 * @returns {Promise}
 */
export async function getSheetsData(spreadsheetsKey, objectStructure, sheetName = 'SHEET1') {
    const API_KEY = 'AIzaSyC8moN_iOP62MS8ZoCpM9AL-pr2WLrnLzg'
    const RANGE = `${sheetName}!A1:ZZZ99999`
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetsKey}/values/${RANGE}`
    const params = {
        alt: 'json',
        majorDimension: 'ROWS',
        key: API_KEY,
    }

    const response = await axios.get(url, { params })

    const jsonRows = getRowsAsJson(response.data.values)

    return jsonRows.map(entry => {
        let returnObject = {}
        for(let key in objectStructure){
            if(entry[objectStructure[key]] == undefined){
                returnObject[key] = ''
            }else{
                returnObject[key] = entry[objectStructure[key]]
            }
        }
        return returnObject
    })
}

function getRowsAsJson(rows){
    const jsonRows = []
    const headerRow = rows[0];
  
    for(let i = 1; i < rows.length; i++){
        const row = rows[i];
    
        const obj = {}
    
        for(let rowI = 0; rowI < headerRow.length; rowI++){
            if(row[rowI] == undefined){
                obj[headerRow[rowI]] = ''
            }else{
                obj[headerRow[rowI]] = row[rowI]
            }
        }
    
        jsonRows.push(obj)
    }
  
    return jsonRows
}